import { createContext, useContext, useEffect, useState } from "react";
import { useProtectedAxiosInstance } from "../hooks/axiosInstance";
import { WorkspaceListRequest } from "../services/Endpoints/workspaces";
import { useNotificationContext } from "./notificationContext";
import errorResolver from "../utils/error-resolver";
import { useProfileContext } from "./profileContext";

export interface IWorkspace {
  id: number;
  name: string;
  website: null | string;
  description: null | string;
  updated_at: string;
  created_at: string;
}

export interface IWorkspaceContext {
  workspace: IWorkspace | null;
  handleSetWorkspace: (payload: IWorkspace) => void;
  workSpaceModal: boolean;
  setWorkSpaceModal: (payload: boolean) => void;
  workspaces: IWorkspace[] | [];
}

const workspaceContext = createContext<IWorkspaceContext>({
  workspace: null,
  handleSetWorkspace: (payload: IWorkspace) => false,
  workSpaceModal: false,
  setWorkSpaceModal: () => false,
  workspaces: [],
});

const getWorkspaceFromStore = () => {
  const workspace = localStorage.getItem("current_workspace");
  if (!workspace || workspace == "undefined") {
    return null;
  }
  return workspace;
};
export function WorkspaceContextProvider({ ...props }: any) {
  const { userProfile } = useProfileContext();
  const _workspace = userProfile ? getWorkspaceFromStore() : null;

  const [workspace, setWorkspace] = useState<IWorkspace | null>(
    _workspace ? JSON.parse(_workspace) : null
  );
  const [workspaces, setWorkspaces] = useState<IWorkspace[] | []>([]);
  const [workSpaceModal, setWorkSpaceModal] = useState(false);
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();

  const handleSetWorkspace = (workspace: IWorkspace) => {
    localStorage.removeItem("current_workspace");
    localStorage.setItem("current_workspace", JSON.stringify(workspace));
    setWorkspace(workspace);
  };

  // useEffect(() => {
  //   const getWorkspaces = async () => {
  //     const workspaceListRequest = new WorkspaceListRequest(protectedInstance);
  //     try {
  //       const resp2 = await workspaceListRequest.send();
  //       setWorkspaces(resp2.data.workspaces);
  //       const curWorkspace = getWorkspaceFromStore();
  //       if (curWorkspace) {
  //         handleSetWorkspace(JSON.parse(curWorkspace));
  //       } else {
  //         handleSetWorkspace(resp2.data.workspaces[0]);
  //       }
  //       if (resp2.data.workspaces.length == 0 && userProfile?.has_password) {
  //         setWorkSpaceModal(true);
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       errorResolver({ error, setNotification });
  //       return error;
  //     }
  //   };
  //   if (userProfile) {
  //     getWorkspaces();
  //   }
  // }, [userProfile]);

  return (
    <workspaceContext.Provider
      value={{
        setWorkspace,
        workspace,
        workSpaceModal,
        handleSetWorkspace,
        setWorkSpaceModal,
        workspaces,
      }}
      {...props}
    />
  );
}

export const useWorkspaceContext = () => useContext(workspaceContext);
